import { useState, useEffect } from 'react';
import styled from 'styled-components';
import ReactPaginate from 'react-paginate';
import useReportDataContext from '../../hooks/useReportDataContext';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
};

const ReportPaginationSection = () => {
  const { totalPages, handlePageChange, pageLimit } = useReportDataContext();
  const isMobile = useIsMobile();

  // Don't render pagination if there's only one page or no pages
  if (totalPages <= 1) {
    return null;
  }

  const currentPage = Math.floor((pageLimit.startIndex - 1) / 25);

  return (
    <Wrapper>
      <ReactPaginate
        pageCount={totalPages}
        forcePage={currentPage}
        marginPagesDisplayed={isMobile ? 1 : 4}
        pageRangeDisplayed={isMobile ? 2 : 3}
        breakLabel={'...'}
        onPageChange={handlePageChange}
        containerClassName={'pagination my-5 justify-content-center'}
        pageClassName={'page-item'}
        pageLinkClassName={'page-link'}
        previousClassName={'page-item'}
        previousLinkClassName={'page-link'}
        nextClassName={'page-item'}
        nextLinkClassName={'page-link'}
        breakLinkClassName={'page-link'}
        activeClassName={'active'}
      ></ReactPaginate>
    </Wrapper>
  );
};

export default ReportPaginationSection;

const Wrapper = styled.section`
  width: 100%;
  height: 100%;
  .pagination {
    font-size: 16px;
    > .page-item,
    .break {
      &.active {
        .page-link {
          background: ${({ theme }) => theme.body};
        }
      }
      .page-link {
        background: ${({ theme }) => theme.background};
        color: ${({ theme }) => theme.text};
        border: 1px solid ${({ theme }) => theme.background};
      }
    }

    @media (max-width: 768px) {
      font-size: 14px;
      gap: 2px;
      .page-link {
        padding: 6px 10px;
      }
    }

    @media (max-width: 480px) {
      font-size: 12px;
      gap: 1px;
      .page-link {
        padding: 4px 8px;
        min-width: 30px;
        text-align: center;
      }
    }
  }
`;
